// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3-CBq","label":"SetPasswdForm_label__2fx7t"};